var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,_vm._b({tag:"component",class:_vm.buttonClasses,on:{"click":function($event){_vm.$emit('click', $event)}}},'component',_vm.resolvedAttrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }